<template>
  <div class="relative">
    <MultiSelectSearch
      :search-groups="searchGroups"
      :selected-items="selectedItemsForSearch"
      :placeholder="currentPlaceholder"
      :input-id="'analytics-search'"
      :min-search-length="2"
      :debounce-delay="300"
      :show-component="true"
      :initial-selections="initialSelections"
      @update-selections="handleUpdateSelections"
      @search="handleSearch"
      @toggle-item="handleToggleItem"
      @clear-results="handleClearResults"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { MultiSelectSearch } from "@estaly/ui";

export default {
  name: "AnalyticsSelector",
  components: {
    MultiSelectSearch,
  },
  emits: ["select-organization", "select-store", "update-selections"],
  data() {
    return {
      selectedOrganizations: [],
      selectedStores: [],
      organizationsResults: [],
      storesResults: [],
    };
  },
  computed: {
    searchGroups() {
      return [
        {
          key: "organizations",
          label: "Organisations",
          items: this.organizationsResults,
          getDisplayName: (org) => org.name,
          isSelected: (orgId) => this.selectedOrganizations.some((org) => org.id === orgId),
        },
        {
          key: "stores",
          label: "Points de vente",
          items: this.storesResults,
          getDisplayName: (store) => store.salesChannel,
          isSelected: (storeId) => this.selectedStores.some((store) => store.id === storeId),
        },
      ];
    },

    initialSelections() {
      return {
        organizations: this.selectedOrganizations,
        stores: this.selectedStores,
      };
    },

    selectedItemsForSearch() {
      const orgs = this.selectedOrganizations.map((org) => ({
        id: org.id,
        label: org.name,
        groupKey: "organizations",
      }));
      const stores = this.selectedStores.map((store) => ({
        id: store.id,
        label: store.salesChannel,
        groupKey: "stores",
      }));
      return [...orgs, ...stores];
    },
  },
  methods: {
    ...mapActions("organizations", { fetchOrganizations: "fetchIndex" }),
    ...mapActions("stores", { fetchStores: "fetchIndex" }),

    async handleSearch(keywords) {
      if (!keywords || keywords.length < 2) return;

      try {
        const [organizationsResponse, storesResponse] = await Promise.all([
          this.fetchOrganizations({ keywords, perPage: 2000 }),
          this.fetchStores({ keywords, perPage: 2000, status: ["active"] }),
        ]);

        this.organizationsResults = organizationsResponse.data.organizations || [];
        this.storesResults = storesResponse.records || [];
      } catch (error) {
        console.error("Error searching:", error);
        this.organizationsResults = [];
        this.storesResults = [];
      }
    },

    handleToggleItem({ item, groupKey }) {
      if (groupKey === "organizations") {
        const index = this.selectedOrganizations.findIndex((org) => org.id === item.id);
        if (index >= 0) {
          this.selectedOrganizations.splice(index, 1);
        } else {
          this.selectedOrganizations = [item];
          this.selectedStores = [];
        }
      } else if (groupKey === "stores") {
        const index = this.selectedStores.findIndex((s) => s.id === item.id);
        if (index >= 0) {
          this.selectedStores.splice(index, 1);
        } else {
          this.selectedStores.push(item);
          this.selectedOrganizations = [];
        }
      }
      this.emitSelections();
    },

    handleUpdateSelections(selections) {
      this.selectedOrganizations = selections.organizations || [];
      this.selectedStores = selections.stores || [];
      this.emitSelections();
    },

    handleClearResults() {
      this.organizationsResults = [];
      this.storesResults = [];
    },

    emitSelections() {
      this.$emit("update-selections", {
        organizations: this.selectedOrganizations,
        stores: this.selectedStores,
      });
    },
  },
};
</script>
